import React, { useEffect, useState } from "react";
import { Col, Form, Row, Tab, Tabs } from "react-bootstrap";
import Select from "react-select";
import { useNavigate, useLocation } from "react-router-dom";
import {
  isAdmin,
  refreshPage,
  toastStyle,
  getTime,
  selectDropdownStyle,
  getBranchId,
  getType,
} from "../../Helpers/Utils/Common";
import {
  deleteTransfer,
  deleteTransferReceive,
  updateTransferStatus,
  searchTransfers,
  searchTransferReceive,
} from "../../Helpers/apiCalls/Inventory/TransferApi";
import DeleteModal from "../../Components/Modals/DeleteModal";
import Navbar from "../../Components/Navbar/Navbar";
import Table from "../../Components/TableTemplate/Table";
import AdjustmentTable from "../../Pages/Inventory/Adjustment/AdjustmentTable";
import TransferModal from "./Transfer/TransferModal";
import DatePicker from "react-datepicker";
import downloadIcon from "../../Assets/Images/download_icon.png";
import * as XLSX from "xlsx";
import toast from "react-hot-toast";
import "./Inventory.css";
import Moment from "moment";
import { searchBranch } from "../../Helpers/apiCalls/Manage/Branches";
import Footer from "../../Components/Footer/Footer";
import TableWithDynamicPagination from "../../Components/TableTemplate/TableWithDynamicPagination";
import AdjustmentTableWithDynamicPagination from "../../Components/TableTemplate/AdjustmentTableWithDynamicPagination";



export default function Transfer() {
  let navigate = useNavigate();
  const { state } = useLocation();
  const [inactive, setInactive] = useState(true);
  const accountType = getType();

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const handleShowDeleteModal = () => setShowDeleteModal(true);
  const handleCloseDeleteModal = () => setShowDeleteModal(false);
  const [transferId, setTransferId] = useState("");
  const [branches, setBranches] = useState([
    { label: "All Branches", value: "" },
  ]);
  const [isClicked, setIsClicked] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [checkedItems, setCheckedItems] = useState([])

  const processedHeaders = [
    "TRANSFER DATE",
    "TRANSFER NO.",
    "DOC NO.",
    "FROM",
    "TO",
    "STATUS",
    "RQT TIME",
    "ENCODED ON",
  ];
  const onHoldHeaders = [
    "TRANSFER DATE",
    "DATE RECEIVED",
    "TRANSFER NO.",
    "DOC NO.",
    "FROM",
    "TO",
    "STATUS",
    "ENCODED ON",
  ];
  const completedHeaders = [
    "TRANSFER DATE",
    "FROM",
    "TO",
    "TRANS NO.",
    "STATUS",
    "ENCODED BY",
    "APPROVED BY",
    "DOC NO.",
    "RQT TIME",
    "TIME PROCESSED",
    "TIME RECEIVED",
    "ENCODED ON",
  ];

  const date = new Date();
  date.setDate(date.getDate() - 7);
  const nextDay = new Date();
  nextDay.setDate(nextDay.getDate() + 1);

  function handleBranchFromChange(e) {
    const toFilter = { target: { name: "branch_from", value: e.value } };
    handleFilterChange(toFilter);
  }

  function handleBranchToChange(e) {
    const toFilter = { target: { name: "branch_to", value: e.value } };
    handleFilterChange(toFilter);
  }

  /** POST API - UPDATE TRANSFER STATUS TO DELETE **/
  async function handleDeleteTransfer() {
    setIsClicked(true);
    //
    //
    if (filterConfig.tab === "on_hold") {
      const response = await deleteTransferReceive(transferId);
      //
      if (response.data) {
        toast.success(response.data.message, {
          style: toastStyle(),
        });
        setTimeout(() => {
          handleCloseDeleteModal();
          refreshPage();
        }, 1000);
      } else {
        response.error?.response?.data?.messages.map((data) => {
            return toast.error(data);
        })
        handleCloseDeleteModal();
        refreshPage();
      }
    } else {
      const response = await deleteTransfer(transferId);
      if (response.data) {
        toast.success(response.data.message, {
          style: toastStyle(),
        });
        setTimeout(() => {
          handleCloseDeleteModal();
          refreshPage();
        }, 1000);
      } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data);
        })
        setTimeout(() => {
          handleCloseDeleteModal();
          refreshPage();
        }, 1000);
      }
    }
  }

  async function handleRequestTransfer() {
    const response = await updateTransferStatus(transferId, "Requested");
    if (response.data) {
      toast.success(response.data.message, {
        style: toastStyle(),
      });
      setTimeout(() => {
        handleCloseApproveModal();
        refreshPage();
      }, 1000);
    } else {
        response.error?.response?.data?.messages.map((data) => {
          return toast.error(data);
        })
      handleCloseApproveModal();
    }
  }

  function handleOnCheck(row) {
    setCheckedItems(row.selectedRows);
  }

  async function handleSelectChange(e, idno, id, status, row, type) {
    switch (e.target.value) {
      case "edit-po":
        navigate("edit/" + id + "/" + status);
        break;

      case "delete-po":
        handleShowDeleteModal();
        if (type === "On hold") {
          setTransferId(row.transfer_id);
        } else {
          setTransferId(idno);
        }
        break;

      case "return-po":
        handleShowApproveModal();
        setTransferId(idno);

        break;

      case "print-po":
        navigate("print/" + id);
        break;

      case "review-po":
        navigate("/transfers/view/" + id + "/" + status);
        break;

        case "review-for-approval":
          navigate("/transfers/view/" + id + "/for_approval");
          break;

      case "view-po":
        navigate("/transfers/view/" + id + "/" + status);
        break;

      case "approve-po":
        navigate("/transfer-receive/update/" + id);
        break;
      default:
        break;
    }
  }

  const [showLoader, setShowLoader] = useState(false);

  /* Approve Modal */
  const [showApproveModal, setShowApproveModal] = useState(false);
  const handleShowApproveModal = () => setShowApproveModal(true);
  const handleCloseApproveModal = () => setShowApproveModal(false);

  const [transferManager, setTransferManager] = useState([]);
  const [filterConfig, setFilterConfig] = useState({
    tab: state === null ? "" : state.tab,
    status: state === null ? "" : state.tab,
    // transfer_status: "requested",
    shop_type: "",
    branch_to: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
    transfer_number: "",
    page: 1
  });
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; // Change this based on your requirement

  const handlePageChange = page => {
    setCurrentPage(page);
    setFilterConfig(prev => ({
      ...prev,
      page: page,
    }));
  };

  async function fetchTransfers() {
    setShowLoader(true);
    setTransferManager([]);
    setTotalItems(0)
    var allData = [];

    const response = await searchTransfers(filterConfig);
    if (response.data) {
      var braddexTransfers = response.data.data;
      braddexTransfers.map((transfer) => {
        var info = {};

        info.id = transfer.id;
        info.request_id = transfer.request_id ? transfer.request_id : "NO REQUEST";
        info.status =
          transfer.status !== "on_hold" ? transfer.status : "On hold";
        info.to_receive = transfer.to_receive;
        info.transfer_date = Moment(transfer.transfer_date).format(
          "MMM DD, YYYY"
        );
        info.date_received = transfer.completed_on
          ? Moment(transfer.completed_on).format("MMM DD, YYYY")
          : "";
        info.added_on = Moment(transfer.added_on).format("MMM DD, YYYY");
        info.added_by = transfer.added_by_name;
        info.transfer_number = transfer.transfer_number;
        info.doc_no = transfer.id;
        info.on_hold_doc_no = transfer.transfer_id;
        info.branch_from = transfer.branch_from;
        info.branch_from_name = transfer.branch_from_name;
        info.branch_to = transfer.branch_to;
        info.branch_to_name = transfer.branch_to_name;
        info.has_for_approval = transfer.has_for_approval === "0" ? "Awaiting" : "For Approval";
        info.is_completed_for_approval = transfer.is_completed_for_approval;
        info.completed_by = transfer.completed_by_name;
        info.approved_by = transfer.approved_by_name;
        info.rqt_time = transfer.request_time ? getTime(transfer.request_time) : "No Request";
        info.time_processed = transfer.time_processed ? getTime(transfer.time_processed) : "";
        info.time_received = transfer.time_received ? getTime(transfer.time_received) : "";
        info.shop_type = "";
        allData.push(info);
        return info;
      });
      setTotalItems(response.data.size);
    }

    var braddexTransfer = allData
      .sort(
        (a, b) =>
          new Date(...a.transfer_date?.split("/").reverse()) -
          new Date(...b.transfer_date?.split("/").reverse())
      )
      .reverse()
      .map((transfer) => {
        var info = transfer;
        return info;
      });
    setTransferManager(braddexTransfer);

    if (filterConfig.tab === "processed,for_adjustment" || filterConfig.tab === "for_approval" || filterConfig.tab === "approved") {
      var excel = braddexTransfer.map((bill) => {
        var info = {};
        info.transfer_date = bill.transfer_date;
        info.transfer_number = bill.transfer_number;
        info.doc_no = bill.doc_no;
        info.branch_from_name = bill.branch_from_name;
        info.branch_to_name = bill.branch_to_name;
        info.status = bill.status;
        info.rqt_time = bill.rqt_time;
        info.added_on = bill.added_on;
        return info;
      });
      setExcelData(excel);
    } else if (
      filterConfig.tab === "completed" ||
      filterConfig.tab === "incomplete" ||
      filterConfig.tab === ""
    ) {
      var tempExcel = braddexTransfer.map((bill) => {
        var info = {};
        info.transfer_date = bill.transfer_date;
        info.branch_from_name = bill.branch_from_name;
        info.branch_to_name = bill.branch_to_name;
        info.transfer_number = bill.transfer_number;
        info.status = bill.status;
        info.added_by = bill.added_by;
        info.approved_by = bill.approved_by;
        info.doc_no = bill.doc_no;
        info.rqt_time = bill.rqt_time;
        info.time_processed = bill.time_processed;
        info.time_received = bill.time_received;
        info.added_on = bill.added_on;
        return info;
      });
      setExcelData(tempExcel);
    }
    setShowLoader(false);
  }

  function handleExport() {
    const rows = excelData;

    /* generate worksheet and workbook */
    const worksheet = XLSX.utils.json_to_sheet(rows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
    if (filterConfig.tab === "processed,for_adjustment") {
      XLSX.utils.sheet_add_aoa(worksheet, [processedHeaders], { origin: "A1" });
      XLSX.writeFile(workbook, "ProcessedTransfers.xlsx", { compression: true });
    } else if (filterConfig.tab === "approved") {
      XLSX.utils.sheet_add_aoa(worksheet, [processedHeaders], { origin: "A1" });
      XLSX.writeFile(workbook, "ApprovedTransfers.xlsx", { compression: true });
    } else if (filterConfig.tab === "gate_pass_generated") {
      XLSX.utils.sheet_add_aoa(worksheet, [processedHeaders], { origin: "A1" });
      XLSX.writeFile(workbook, "GatePassGeneratedTransfers.xlsx", { compression: true });
    } else if (filterConfig.tab === "for_approval") {
      XLSX.utils.sheet_add_aoa(worksheet, [processedHeaders], { origin: "A1" });
      XLSX.writeFile(workbook, "ForApprovalTransfers.xlsx", { compression: true, });
    } else if (filterConfig.tab === "completed") {
      XLSX.utils.sheet_add_aoa(worksheet, [completedHeaders], { origin: "A1" });
      XLSX.writeFile(workbook, "CompletedTransfers.xlsx", {compression: true});
    } else if (filterConfig.tab === "incomplete") {
      XLSX.utils.sheet_add_aoa(worksheet, [completedHeaders], { origin: "A1" });
      XLSX.writeFile(workbook, "IncompleteTransfers.xlsx", {compression: true});
    } else if (filterConfig.tab === "") {
      XLSX.utils.sheet_add_aoa(worksheet, [completedHeaders], { origin: "A1" });
      XLSX.writeFile(workbook, "AllTransfers.xlsx", { compression: true });
    }
  }

  const handleTabSelect = (tabKey) => {
    setCurrentPage(1)
    if (tabKey === "") {
      setFilterConfig((prev) => {
        return {
          ...prev,
          tab: "",
          status: "",
          transfer_status: "",
          branch_from: "",
          branch_to: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
          transfer_date_from: "",
          transfer_date_to: "",
          page: 1
        };
      });
    } else if (tabKey==="for_approval") {
      setFilterConfig((prev) => {
        return {
          ...prev,
          tab: "for_approval",
          status: "pending",
          transfer_status: "for_approval",
          branch_from: "",
          branch_to: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
          transfer_date_from: "",
          transfer_date_to: "",
          page: 1
        };
      });
    } else if (tabKey==="approved") {
      setFilterConfig((prev) => {
        return {
          ...prev,
          tab: "approved",
          status: "pending",
          transfer_status: "approved",
          branch_from: "",
          branch_to: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
          transfer_date_from: "",
          transfer_date_to: "",
          page: 1
        };
      });
    } else if (tabKey === "completed") {
      setFilterConfig((prev) => {
        return {
          ...prev,
          tab: tabKey,
          status: tabKey,
          transfer_status: "gate_pass_generated",
          branch_from: "",
          branch_to: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
          transfer_date_from: new Date(date),
          transfer_date_to: new Date(nextDay),
          page: 1
        };
      });
    } else if (tabKey === "incomplete"){
      setFilterConfig((prev) => {
        return {
          ...prev,
          tab: tabKey,
          status: tabKey,
          transfer_status: "gate_pass_generated",
          branch_from: "",
          branch_to: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
          transfer_date_from: "",
          transfer_date_to: "",
          page: 1
        };
      });
    
    } else if(tabKey === "gate_pass_generated") {
      setFilterConfig((prev) => {
        return {
          ...prev,
          tab: tabKey,
          status: "pending",
          transfer_status: "gate_pass_generated",
          branch_from: "",
          branch_to: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
          transfer_date_from: "",
          transfer_date_to: "",
          page: 1
        };
      });
    } else {
      setFilterConfig((prev) => {
        return {
          ...prev,
          tab: tabKey,
          status: tabKey,
          transfer_status: "",
          branch_from: "",
          branch_to: (accountType === "branch_oic" || accountType === "branch_inventory_officer") ? getBranchId() : "",
          transfer_date_from: "",
          transfer_date_to: "",
          page: 1
        };
      });
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterConfig((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  useEffect(() => {
    fetchTransfers();
  }, [filterConfig, currentPage]);

  async function fetchBranches() {
    setBranches([]);

    const response = await searchBranch({ is_franchise: "0,1,3" });
    if (response.data) {
      var branches = response.data.data.map((data) => {
        var branch = data;
        branch.label = data.name;
        branch.value = data.id;
        return branch
      });
      if(accountType === "branch_oic" || accountType === "branch_inventory_officer") {
          var filteredBranch = branches.filter((data) => {
          return data.id === getBranchId()
          })
          setBranches(filteredBranch);
      } else {
          setBranches([{label: "All Branches", value:""}, ...branches]);
      }
    }
  }

  function ReviewTransfer(row, tab) {
    return (
      <button
        type="button"
        className="btn btn-sm view-btn-table"
        onClick={() => handleReviewTransfer(row.doc_no, row.status, tab)}
      >
        {
          tab === "for_approval" ? "Review" : "View"
        }
      </button>
    );
  }

  function handleReviewTransfer(id, transfer_status, tab) {
    if(tab === "for_approval") {
      navigate("/transfers/view/" + id + "/for_approval");
    } else {
      navigate("/transfers/view/" + id + "/" + transfer_status);
    }
  }

  // function ReceiveBtn(row, type) {
  //   if (row.to_receive === "1") {
  //     return (
  //       <button
  //         name="action"
  //         className="btn btn-sm view-btn-table"
  //         id={row.id}
  //         onClick={(e) => handleReceiveTransfer(row.doc_no, row.status)}
  //         value="receive-po"
  //       >
  //         Receive
  //       </button>
  //     );
  //   }
  // }
  // function handleReceiveTransfer(id, transfer_status) {
  //   navigate("/transfer-receive/create/" + id);
  // }

  function ReviewOnHold(row) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.id}
        onClick={(e) => handleReviewOnHold(row.doc_no, row.status)}
        value="receive-po"
      >
        Approve
      </button>
    );
  }
  function handleReviewOnHold(id) {
    navigate("/transfer-receive/update/" + id);
  }

  function ReceiveBtn(row) {
    if(row.is_completed_for_approval === "0") {
      return (
        <button
          name="action"
          className="btn btn-sm view-btn-table"
          id={row.id}
          onClick={(e) => handleReceiveTransfer(row.doc_no, row.status)}
        >
          Receive
        </button>
      );
    } 
  }
  function handleReceiveTransfer(id) {
    navigate("/transfer-receive/create/" + id);
  }

  function GenerateGatepass(row) {
    return (
      <button
        name="action"
        className="btn btn-sm view-btn-table"
        id={row.id}
        onClick={() => handleGenerateGatepass("single", row)}
      >
        Create GP
      </button>
    );
  }
  function handleGenerateGatepass(type, row) {
    if (type === "single") {
      navigate("/gatepass/add/" + row.id, {
              state: { 
                transfer_data: row,
                transfer_ids: [row.id]},
            })
    } else {
      var ids = checkedItems.map((data) => {
        return data.id
      })
      navigate("/gatepass/add/0", {
              state: { transfer_ids: ids },
            })
    }
    // navigate("/transfer-receive/create/" + id);
  }

  function ActionBtn(row, type) {
    //
    return (
      <Form.Select
        name="action"
        className="PO-select-action"
        id={row.id}
        onChange={(e) =>
          handleSelectChange(e, row.id, row.doc_no, row.status, row, type)
        }
      >
        <option value="" selected hidden>
          Select
        </option>

        {type === "deleted" ? (
          <>
            <option value="view-po" className="color-options">
              View
            </option>
            <option value="return-po" className="color-options">
              Return to Requested
            </option>
          </>
        ) : (
          <>
            {type === "approved" ? (
              <>
                <option value="view-po" className="color-options">
                  View
                </option>
                {isAdmin() && (
                  <option value="delete-po" className="color-red">
                    Delete
                  </option>
                )}
              </>
            ) : (
              <>
                {type === "incomplete" ? (
                // {type === "processed" ? (
                  <>
                    <option value="view-po" className="color-options">
                      View
                    </option>
                    <option value="receive-po" className="color-options">
                      Receive
                    </option>
                    {isAdmin() && (
                      <option value="delete-po" className="color-red">
                        Delete
                      </option>
                    )}
                  </>
                ) : (
                  <>
                    {type === "disapproved" ? (
                      <option value="return-po" className="color-yellow">
                        Return to Pending
                      </option>
                    ) : (
                      <>
                        {type === "all" && (
                          <>
                            <option value="view-po" className="color-options">
                              View
                            </option>
                          </>
                        )}
                      </>
                    )}
                  </>
                )}{" "}
                :{" "}
                {type === "requested" ? (
                  <>
                    <option value="review-po" className="color-options">
                      Review
                    </option>
                    {isAdmin() && (
                      <option value="delete-po" className="color-red">
                        Delete
                      </option>
                    )}
                  </>
                ) : (
                  <>
                    {type === "on_hold" && (
                      <>
                        <option value="approve-po" className="color-options">
                          Approve
                        </option>
                        {isAdmin() && (
                          <option value="delete-po" className="color-red">
                            Delete
                          </option>
                        )}
                      </>
                    )}
                  </>
                )}
                {
                    type === "for_approval" && (
                      <>
                    <option value="review-for-approval" className="color-options">
                      Review for Approval
                    </option>
                    {isAdmin() && (
                      <option value="delete-po" className="color-red">
                        Delete
                      </option>
                    )}
                  </>
                    )
                  }
              </>
            )}
          </>
        )}
      </Form.Select>
    );
  }

  return (
    <div>
      <div className="page">
        <Navbar
          onCollapse={(inactive) => {
            setInactive(inactive);
          }}
          active={"TRANSFERS"}
        />
      </div>

      <div className={`manager-container ${inactive ? "inactive" : "active"}`}>
        {/* headers */}
        <Row className="mb-2">
          <Col xs={12} lg={7}>
              <h1 className="page-title ps-2 ms-3 ms-md-0 ps-md-0 ms-md-0 fs-2"> TRANSFERS </h1>
          </Col>
          <Col xs={12} lg={3} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
              <input
                type="search"
                name="transfer_number"
                className="search-bar"
                placeholder="Search transfer number..."
                onKeyPress={(e) =>
                  e.key === ("Enter" || "NumpadEnter") && handleFilterChange(e)
                }
              />
          </Col>
          <Col lg={2} className="mt-4 mt-lg-0">
              <div className="PO-filters">
                <button
                  className="add-btn"
                  onClick={() => navigate("/transfers/add")}
                >
                  Add
                </button>
              </div>
          </Col>
        </Row>
        <Row className="mb-2">
          {
            (filterConfig.tab === "approved" && checkedItems.length > 0) && (
              <>
              <Col xs={12} lg={12} className="d-flex justify-content-end force-width flex-column flex-lg-row gap-3">
                <div className="d-flex justify-content-end pr-0">
                  <button
                    type="button"
                    className="button-secondary"
                    onClick={() => handleGenerateGatepass("multiple", "")}
                  >
                    Generate GP
                  </button>
                </div>
              </Col>
              </>
            )
          }
        </Row>

        {/* tabs */}
        <Tabs
          activeKey={filterConfig.tab}
          defaultActiveKey={filterConfig.tab}
          id="PO-tabs"
          onSelect={handleTabSelect}
        >
          <Tab eventKey="for_approval" title="for approval">
            {/* filters */}
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter px-0 py-0 me-2"
                  classNamePrefix="react-select"
                  placeholder={"Branch From"}
                  styles={selectDropdownStyle}
                  // value={branchFrom}
                  options={branches}
                  onChange={handleBranchFromChange}
                />
              </Col>
              <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter px-0 py-0 me-2"
                  classNamePrefix="react-select"
                  placeholder="Branch To"
                  styles={selectDropdownStyle}
                  // value={branchTo}
                  options={branches}
                  onChange={handleBranchToChange}
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.transfer_date_from}
                  placeholderText={"Select Date From"}
                  name="transfer_date_from"
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, transfer_date_from: date };
                    });
                  }}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.transfer_date_to}
                  placeholderText={"Select Date To"}
                  name="transfer_date_to"
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, transfer_date_to: date };
                    });
                  }}
                  minDate={filterConfig.date_from}
                  className="date-filter ps-label-content me-5 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className="mb-2" />

            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                " ",
                "TRANSFER DATE",
                "TRANSFER NO.",
                "DOC NO.",
                "FROM",
                "TO",
                "STATUS",
                "RQT TIME",
                "ENCODED ON",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "",
                "transfer_date",
                "transfer_number",
                "doc_no",
                "branch_from_name",
                "branch_to_name",
                "status",
                "rqt_time",
                "added_on",
              ]}
              tableData={transferManager}
              ActionBtn={(row) => ActionBtn(row, "for_approval")}
              ViewBtn={(row) => ReviewTransfer(row, "for_approval")}
              handleOnCheck={(row) => handleOnCheck(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
          <Tab eventKey="approved" title="approved">
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter px-0 py-0 me-2"
                  classNamePrefix="react-select"
                  placeholder={"Branch From"}
                  styles={selectDropdownStyle}
                  // value={branchFrom}
                  options={branches}
                  onChange={handleBranchFromChange}
                />
              </Col>
              <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter px-0 py-0 me-2"
                  classNamePrefix="react-select"
                  placeholder="Branch To"
                  styles={selectDropdownStyle}
                  // value={branchTo}
                  options={branches}
                  onChange={handleBranchToChange}
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.transfer_date_from}
                  placeholderText={"Select Date From"}
                  name="transfer_date_from"
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, transfer_date_from: date };
                    });
                  }}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.transfer_date_to}
                  placeholderText={"Select Date To"}
                  name="transfer_date_to"
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, transfer_date_to: date };
                    });
                  }}
                  minDate={filterConfig.date_from}
                  className="date-filter ps-label-content me-5 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className="mb-2" />

            {/* table */}
            <AdjustmentTableWithDynamicPagination
              tableHeaders={[
                "-",
                " ",
                "TRANSFER DATE",
                "TRANSFER NO.",
                "DOC NO.",
                "FROM",
                "TO",
                "STATUS",
                "RQT TIME",
                "ENCODED ON",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                " ",
                "transfer_date",
                "transfer_number",
                "doc_no",
                "branch_from_name",
                "branch_to_name",
                "status",
                "rqt_time",
                "added_on",
              ]}
              tableData={transferManager}
              ActionBtn={(row) => ActionBtn(row, "approved")}
              ViewBtn={(row) => ReviewTransfer(row, "approved")}
              PendingBtn={(row) => GenerateGatepass(row)}
              handleOnCheck={(row) => handleOnCheck(row)}
              // PendingBtn={(row) => ReceiveBtn(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
          <Tab eventKey="gate_pass_generated" title="GP GENERATED">
          <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter px-0 py-0 me-2"
                  classNamePrefix="react-select"
                  placeholder={"Branch From"}
                  styles={selectDropdownStyle}
                  // value={branchFrom}
                  options={branches}
                  onChange={handleBranchFromChange}
                />
              </Col>
              <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter px-0 py-0 me-2"
                  classNamePrefix="react-select"
                  placeholder="Branch To"
                  styles={selectDropdownStyle}
                  // value={branchTo}
                  options={branches}
                  onChange={handleBranchToChange}
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.transfer_date_from}
                  placeholderText={"Select Date From"}
                  name="transfer_date_from"
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, transfer_date_from: date };
                    });
                  }}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.transfer_date_to}
                  placeholderText={"Select Date To"}
                  name="transfer_date_to"
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, transfer_date_to: date };
                    });
                  }}
                  minDate={filterConfig.date_from}
                  className="date-filter ps-label-content me-5 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className="mb-2" />

            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                " ",
                "TRANSFER DATE",
                "TRANSFER NO.",
                "DOC NO.",
                "FROM",
                "TO",
                "STATUS",
                "RECEIVE STATUS",
                "RQT TIME",
                "ENCODED ON",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                " ",
                "transfer_date",
                "transfer_number",
                "doc_no",
                "branch_from_name",
                "branch_to_name",
                "status",
                "has_for_approval",
                "rqt_time",
                "added_on",
              ]}
              tableData={transferManager}
              ActionBtn={(row) => ActionBtn(row, "approved")}
              ViewBtn={(row) => ReviewTransfer(row, "approved")}
              PendingBtn={(row) => ReceiveBtn(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>


          {/* <Tab eventKey="on_hold" title="on hold">
            <div className="my-2 px-4 PO-filters d-flex">
              <span className="me-4 align-middle mt-2">Filter By:</span>

              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder={"Branch From"}
                styles={selectDropdownStyle}
                options={branches}
                onChange={handleBranchFromChange}
              />
              <Select
                className="dropsearch-filter px-0 py-0 me-2"
                classNamePrefix="react-select"
                placeholder="Branch To"
                styles={selectDropdownStyle}
                options={branches}
                onChange={handleBranchToChange}
              />

              <span className="me-3 align-middle mt-2">Date From:</span>
              <DatePicker
                autoComplete="off"
                selected={filterConfig.transfer_date_from}
                placeholderText={"Select Date"}
                name="transfer_date_from"
                onChange={(date) => {
                  setFilterConfig((prev) => {
                    return { ...prev, transfer_date_from: date };
                  });
                }}
                fixedHeight
                className="PI-date-btn me-3 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />

              <span className="me-3 align-middle mt-2">To:</span>
              <DatePicker
                autoComplete="off"
                selected={filterConfig.transfer_date_to}
                placeholderText={"Select Date"}
                name="transfer_date_to"
                onChange={(date) => {
                  setFilterConfig((prev) => {
                    return { ...prev, transfer_date_to: date };
                  });
                }}
                minDate={filterConfig.date_from}
                className="PI-date-btn me-3 form-control"
                showYearDropdown
                dateFormatCalendar="MMMM"
                yearDropdownItemNumber={20}
                scrollableYearDropdown
              />
            </div>

            <Table
              tableHeaders={[
                "-",
                "TRANSFER DATE",
                "DATE RECEIVED",
                "ENCODED ON",
                "TRANSFER NO.",
                "DOC NO.",
                "FROM",
                "TO",
                "STATUS",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "transfer_date",
                "date_received",
                "added_on",
                "transfer_number",
                "on_hold_doc_no",
                "branch_from_name",
                "branch_to_name",
                "status",
              ]}
              tableData={transferManager}
              ActionBtn={(row) => ActionBtn(row, "on_hold")}
              ViewBtn={(row) => ReviewOnHold(row)}
              showLoader={showLoader}
            />
            <div className="mb-2" />
          </Tab> */}

          <Tab eventKey="incomplete" title="incomplete">
          {/* <Tab eventKey="processed,for_adjustment" title="processed"> */}
            {/* filters */}
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter px-0 py-0 me-2"
                  classNamePrefix="react-select"
                  placeholder={"Branch From"}
                  styles={selectDropdownStyle}
                  // value={branchFrom}
                  options={branches}
                  onChange={handleBranchFromChange}
                />
              </Col>
              <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter px-0 py-0 me-2"
                  classNamePrefix="react-select"
                  placeholder="Branch To"
                  styles={selectDropdownStyle}
                  // value={branchTo}
                  options={branches}
                  onChange={handleBranchToChange}
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.transfer_date_from}
                  placeholderText={"Select Date From"}
                  name="transfer_date_from"
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, transfer_date_from: date };
                    });
                  }}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.transfer_date_to}
                  placeholderText={"Select Date To"}
                  name="transfer_date_to"
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, transfer_date_to: date };
                    });
                  }}
                  minDate={filterConfig.date_from}
                  className="date-filter ps-label-content me-5 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className="mb-2" />

            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                " ",
                "TRANSFER DATE",
                "TRANSFER NO.",
                "DOC NO.",
                "FROM",
                "TO",
                "STATUS",
                "RQT TIME",
                "TIME PROCESSED",
                "TIME RECEIVED",
                "ENCODED ON",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                " ",
                "transfer_date",
                "transfer_number",
                "doc_no",
                "branch_from_name",
                "branch_to_name",
                "status",
                "rqt_time",
                "time_processed",
                "time_received",
                "added_on",
              ]}
              tableData={transferManager}
              ActionBtn={(row) => ActionBtn(row, row.status)}
              ViewBtn={(row) => ReviewTransfer(row, "approved")}
              PendingBtn={(row) => ReceiveBtn(row)}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>

          <Tab eventKey="completed" title="completed">
            {/* filters */}
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter px-0 py-0 me-2"
                  classNamePrefix="react-select"
                  placeholder={"Branch From"}
                  styles={selectDropdownStyle}
                  // value={branchFrom}
                  options={branches}
                  onChange={handleBranchFromChange}
                />
              </Col>
              <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter px-0 py-0 me-2"
                  classNamePrefix="react-select"
                  placeholder="Branch To"
                  styles={selectDropdownStyle}
                  // value={branchTo}
                  options={branches}
                  onChange={handleBranchToChange}
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.transfer_date_from}
                  placeholderText={"Select Date From"}
                  name="transfer_date_from"
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, transfer_date_from: date };
                    });
                  }}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.transfer_date_to}
                  placeholderText={"Select Date To"}
                  name="transfer_date_to"
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, transfer_date_to: date };
                    });
                  }}
                  minDate={filterConfig.date_from}
                  className="date-filter ps-label-content me-5 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className="mb-2" />

            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "DATE TRANSFER",
                "FROM",
                "TO",
                "TRANS NO.",
                "STATUS",
                "ENCODED BY",
                "APPROVED BY",
                "DOC NO.",
                "RQT TIME",
                "TIME PROCESSED",
                "TIME RECEIVED",
                "ENCODED ON",
              ]}
              headerSelector={[
                "-",
                "transfer_date",
                "branch_from_name",
                "branch_to_name",
                "transfer_number",
                "status",
                "added_by",
                "approved_by",
                "doc_no",
                "rqt_time",
                "time_processed",
                "time_received",
                "added_on",
              ]}
              tableData={transferManager}
              ViewBtn={(row) => ReviewTransfer(row, "completed")}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>

          <Tab eventKey="" title="all" className="manager-tabs">
            {/* filters */}
            <div className="mb-3" />
            <span className="ps-3 mb-2 align-middle d-none d-md-inline d-flex text-secondary">
                Filter By:
            </span>
            <Row className="PO-filters flex flex-row mx-2 my-1">
              <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter px-0 py-0 me-2"
                  classNamePrefix="react-select"
                  placeholder={"Branch From"}
                  styles={selectDropdownStyle}
                  // value={branchFrom}
                  options={branches}
                  onChange={handleBranchFromChange}
                />
              </Col>
              <Col xs={6} lg={4} className="mb-2 mb-lg-0">
                <Select
                  className="dropsearch-filter px-0 py-0 me-2"
                  classNamePrefix="react-select"
                  placeholder="Branch To"
                  styles={selectDropdownStyle}
                  // value={branchTo}
                  options={branches}
                  onChange={handleBranchToChange}
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.transfer_date_from}
                  placeholderText={"Select Date From"}
                  name="transfer_date_from"
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, transfer_date_from: date };
                    });
                  }}
                  fixedHeight
                  className="date-filter me-4 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
              <Col xs={6} lg={2}>
                <DatePicker
                  autoComplete="off"
                  selected={filterConfig.transfer_date_to}
                  placeholderText={"Select Date To"}
                  name="transfer_date_to"
                  onChange={(date) => {
                    setFilterConfig((prev) => {
                      return { ...prev, transfer_date_to: date };
                    });
                  }}
                  minDate={filterConfig.date_from}
                  className="date-filter ps-label-content me-5 form-control"
                  showYearDropdown
                  dateFormatCalendar="MMMM"
                  yearDropdownItemNumber={20}
                  scrollableYearDropdown
                />
              </Col>
            </Row>
            <div className="mb-2" />

            {/* table */}
            <TableWithDynamicPagination
              tableHeaders={[
                "-",
                "DATE TRANSFER",
                "FROM",
                "TO",
                "TRANS NO.",
                "STATUS",
                "ENCODED BY",
                "APPROVED BY",
                "DOC NO.",
                "RQT TIME",
                "TIME PROCESSED",
                "TIME RECEIVED",
                "ENCODED ON",
                "REQUEST ID",
                "ACTIONS",
              ]}
              headerSelector={[
                "-",
                "transfer_date",
                "branch_from_name",
                "branch_to_name",
                "transfer_number",
                "status",
                "added_by",
                "approved_by",
                "doc_no",
                "rqt_time",
                "time_processed",
                "time_received",
                "added_on",
                "request_id",
              ]}
              tableData={transferManager}
              ActionBtn={(row) => ActionBtn(row, "all")}
              showLoader={showLoader}
              // used in dynamic pagination
              totalItems={totalItems}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              handlePageChange={handlePageChange}
            />
            <div className="mb-2" />
          </Tab>
        </Tabs>
<br />
                <Row>
                    <Col lg={10}></Col>
                    <Col lg={2} className="mt-3 mt-lg-0">
                    <div className="PO-filters">
                        <button
                            type="button"
                            className="primary-btn"
                            onClick={handleExport}
                        >
                            <span className="me-2">
                                <img
                                    width={20}
                                    height={20}
                                    src={downloadIcon} alt=""
                                ></img>
                            </span>
                            Download
                        </button>
                    </div>
                    </Col>
                </Row>
                <div className="mb-3" />
                <br /><br />
      </div>

      {/* modals */}
      <DeleteModal
        show={showDeleteModal}
        onHide={() => handleCloseDeleteModal()}
        text="transfer"
        onDelete={() => handleDeleteTransfer()}
        isClicked={isClicked}
      />
      <TransferModal
        show={showApproveModal}
        hide={handleCloseApproveModal}
        type="Return to Request"
        handler={handleRequestTransfer}
      />
      <Footer/>
    </div>
  );
}
